// Maps known Cal.com booking-error codes to i18n keys under `products.error.*`.
// The raw code is still useful for Sentry; this only governs what subscribers see.
const ERROR_MAP: Record<string, string> = {
  no_available_users_found_error: 'products.error.host_unavailable',
};

export const mapCalComBookingError = (rawError: string | null | undefined): string | null => {
  if (!rawError) return null;
  return ERROR_MAP[rawError] ?? null;
};
